// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import {
    InitialFeesTypeState,
    FeesTypeSchema,
    FeesTypeFormFields,
} from "./Configuration.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";
const FeesType = ({ id, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [fees_type, setFeesType] = useState(InitialFeesTypeState);
    const [formFields, setFormFields] = useState(FeesTypeFormFields);

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name && (field.type === "select" || field.type === "multiselect")
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const getSchoolsByCompanies = async () => {
        spinService.on();
        const response = await get(EntityConstants.SCHOOLSBYCOMPANIES);
        const data = await response.json();
        attachOptions("schools", data);
        spinService.off();
    };

    const getFeesType = async (id) => {
        spinService.on();
        const response = await get(EntityConstants.FEES_TYPES + `/${id}`);
        const data = await response.json();
        setFeesType(data);
        spinService.off();
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewFeesType = values.id === undefined;
        values.invoice = values.invoice === 'true' ? true : false;
        const url = isNewFeesType ? EntityConstants.FEES_TYPES : EntityConstants.FEES_TYPES + `/${values.id}`;
        const method = isNewFeesType ? post : put;
        const response = await method(url, { fees_type: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewFeesType ? MessageContants.FEES_TYPE_CREATED : MessageContants.FEES_TYPE_UPDATED);
            onClose();
        }
        spinService.off();
    };

    useEffect(() => {
        getSchoolsByCompanies();
        if (id !== undefined) {
            getFeesType(Number(id));
        }
    }, [id]);

    return (
        <Formik
            enableReinitialize
            initialValues={fees_type}
            validationSchema={FeesTypeSchema}
            onSubmit={(values) => handleSubmit(values)}
        >
            {({
                values,
                touched,
                errors,
                dirty,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <StyledDrawerForm>
                        <Grid
                            container
                            maxWidth="sm"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                        >
                            {formFields.map((formField, index) => {
                                return (
                                    <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                                        <GoForm
                                            config={formField}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            handleChange={handleChange}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                        <Box sx={{ p: 2, textAlign: "right" }}>
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<Iconify icon="eva:close-circle-outline" />}
                                onClick={() => onClose()}
                            >
                                Close
                            </Button>
                            &nbsp;&nbsp;
                            {((values.id === undefined && permissions.has(PermissionConstants.FEES_TYPE_CREATE)) || (values.id !== undefined && permissions.has(PermissionConstants.FEES_TYPE_UPDATE))) &&
                                <Button
                                    variant="contained"
                                    startIcon={<Iconify icon="eva:save-fill" />}
                                    type="submit"
                                >
                                    {values.id === undefined ? 'Save' : 'Update'}
                                </Button>
                            }
                        </Box>
                    </StyledDrawerForm>
                </Form>
            )}
        </Formik>
    );
};

FeesType.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default FeesType;
